export const WizardDirection = 'WizardDirection';

// CalibrationPage
export const CalibrationPageTopMenuProp = 'CalibrationPageTopMenuProp';
// SystemSetting
export const SaveDeviceSetting = 'SaveDeviceSetting';

// manual control
export const TopButtonStatusType = 'TopButtonStatusType';
export const TopButtonStatusTypeAutoProfile = 'TopButtonStatusTypeAutoProfile';
